export const TITLE = 'Get to Know Cornerstone Homes';

export const QUOTE = `"We take pride in building custom homes that reflect our clients' unique visions\u2014delivering exceptional craftsmanship with honesty, integrity, and a family friendly environment."`;

export const MISSION_STATEMENT = `We are dedicated to providing our clients with top notch craftsmanship while maintaining a strong commitment to integrity and honesty in all of our business relationships`;

export const PARAGRAPHS = [
  `At Cornerstone Homes, we're more than just builders --- we're dreamers, creators, and visionaries dedicated to bringing your home projects to life. With a passion for craftsmanship and a commitment to excellence, we take pride in every home we build and every renovation we undertake.`,
  `Our journey began with Craig and Julie, who shared the belief that everyone deserves a home reflecting their unique style and personality. Since building our first house in 2002, we have helped countless clients turn their houses into homes --- from homey kitchens to stunning mansions, we make your dreams a reality.`,
  `Our story doesn't end with the homes we build; it continues with the lives we impact and the relationships we create along the way. We value transparency, integrity, and communication, striving to make every client feel like part of the Cornerstone family.`,
  `Whether you're designing a custom home, renovating an existing space, or simply exploring the possibilities, we're here to guide you every step of the way. Welcome to Cornerstone Homes --- where your vision becomes our mission.`,
];

/*
 * Images
 */
export const OUR_TEAM_SECTION_IMAGE = 'pages/about-us/IMG_0538_ffauii';
export const OUR_TEAM_SECTION_BG_IMAGE =
  'projects/River Ranch/1-web-or-mls-130-_xm4zyq';

// Photo collage images
export const COLLAGE_IMAGE_TEAM = 'pages/about-us/CRAIG_HEADSHOT_dj3ood';
export const COLLAGE_IMAGE_FAMILY = 'pages/about-us/JULIE_HEADSHOT_au3w5y';
export const COLLAGE_IMAGE_PORTRAIT = 'pages/about-us/ABBY_HEADSHOT_oi4t1b';
